import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({ iconSize = '', iconName, label, onClick, link = null, textColor = 'text-primary', styles = '' }) => {
  IconButton.propTypes = {
    iconSize: PropTypes.string,
    iconName: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    link: PropTypes.string,
    textColor: PropTypes.string,
    styles: PropTypes.string
  };

  const attributes = { style: { textDecoration: 'none' } };

  if (link === null) {
    return (
      <React.Fragment>
        <div {...attributes} href={link} className={`btn btn-link ${styles} ${textColor}`} onClick={onClick}>
          <div className={`${iconSize} m-0`}><i className={iconName} /></div>
          <small
            style={{ lineHeight: '15px', display: 'block' }}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <a {...attributes} href={link} className={`btn btn-link ${styles} ${textColor}`} onClick={onClick}>
        <div className={`${iconSize} m-0`}>
          <i className={iconName} />
        </div>
        <small
          style={{ lineHeight: '15px', display: 'block' }}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      </a>
    </React.Fragment>
  );
};

export default IconButton;
